/*
Post Types:
-1: Upcoming Fight Placeholder Toast
0: Text Toast
1: Image/Text Toast
2: Social Toast
3: Stat Toast
- statType 0: 2-Fighter Comparison (2 fighters, 1 shared stat metric)
- statType 1: Single Stat (1 fighter, 1 stat metric)
- statType 2: Multi-Stat (1 fighter, 3 stat metrics)
4: Insights Toast
*/

<script setup>
import { ref, computed, onMounted, onUnmounted, useTemplateRef } from "vue";
import { useStore } from "vuex";
import SocialContent from "@/components/SocialContent.vue";


const store = useStore();
const currentTime = ref(Date.now());
const currentCardIdx = ref(0);
const totalPostsSize = computed(() => renderedCardList.value.length)

const renderedCardList = ref([]);

const cardListRefs = useTemplateRef('card-list')
const hiderElement = useTemplateRef('hider-element')

const hiddenPostOffset = ref(0);
const topPostOffset = ref(0);
const activePostOffset = ref(0);

const currentAppliedOffset = ref(0);
const isControlsLocked = ref(false);
const isHiding = ref(false);

const scrollToTopCard = () => {
    calculateTotalOffset();
    currentCardIdx.value = totalPostsSize.value - 1;
    currentAppliedOffset.value = topPostOffset.value;
    isHiding.value = false;
    //cardListRefs.value[currentCardIdx.value].children[0].focus()
}

const hideAll = () => {
    calculateTotalOffset();
    currentAppliedOffset.value = hiddenPostOffset.value + 300;
    currentCardIdx.value = -1;
    isHiding.value = true;
}

const onFocusUpdated = (event) => {
    console.log(event.detail)
    currentCardIdx.value = event.detail;
}

const calculateFadeoutOpacity = (index) => {
    let distance = Math.abs(currentCardIdx.value - index);
    return 1;
}

const calculateTotalOffset = () => {
    let offset = 0;
    activePostOffset.value = 0;
    for (let i = 0; i < cardListRefs.value?.length; i++) {
        let style = getComputedStyle(cardListRefs.value[i]);
        offset += cardListRefs.value[i].offsetHeight;
        offset += parseFloat(style.marginTop);
        offset += parseFloat(style.marginBottom);

        if(i == currentCardIdx.value - 1){
            activePostOffset.value = offset;
        }

    }

    hiddenPostOffset.value = offset - 10; // TODO figure out why i need this 10 here
    topPostOffset.value = hiddenPostOffset.value - cardListRefs.value?.at(-1).offsetHeight;

}

function formatEventName(eventName) {
    if (eventName.includes(':') && eventName.indexOf(':') > 0) {
        return eventName.split(':')[1].trim();
    }
    return eventName.trim();
}

async function toastAdded() {
    isControlsLocked.value = true;

    //If you're on the top card, hide it first
    hideAll();
    await new Promise(resolve => setTimeout(resolve, 600));
    
    console.log("adding to card list")
    renderedCardList.value = store.getters.cardList;
    await new Promise(resolve => setTimeout(resolve, 100));
    calculateTotalOffset();
    await new Promise(resolve => setTimeout(resolve, 100));
    scrollToTopCard();
    isControlsLocked.value = false;
}

async function toastCleared() {
    // Only clear toast if you're currently looking at it
    if (currentCardIdx.value == cardListRefs.value?.length - 1) {
        hideAll();
    }
}

function formatTimestamp(isoString, suffix) {
    const date = new Date(isoString);

    const formatter = new Intl.DateTimeFormat('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short'
    });

    // Destructure into parts
    const parts = Object.fromEntries(
        formatter.formatToParts(date).map(p => [p.type, p.value])
    );

    const formattedDate = `${parts.weekday}, ${parts.month} ${parts.day} 
        / ${parts.hour}:${parts.minute} ${parts.dayPeriod} ${parts.timeZoneName}`;

    return suffix ? `${formattedDate} / ${suffix}` : formattedDate;
}

const scrollToActiveCard=()=>{
    if(currentCardIdx.value < 0) return;
    console.log("current card", currentCardIdx.value)
    cardListRefs.value[currentCardIdx.value].children[0].focus()

    cardListRefs.value[currentCardIdx.value].scrollIntoView({
        block: 'end',
        inline: 'nearest',
        behavior: 'smooth'
    });
}

const scrollUp = () => {
    if(isControlsLocked.value) return;

    if (currentCardIdx.value < 0) return;
    if(currentCardIdx.value + 1 >= totalPostsSize.value){
        hideAll()
    } else {
        currentCardIdx.value++;
        calculateTotalOffset();
        currentAppliedOffset.value = activePostOffset.value;
        isHiding.value = false;
        //cardListRefs.value[currentCardIdx.value].children[0].focus()
    }
}

const scrollDown = () => {
    if (isControlsLocked.value) return;

    if (currentCardIdx.value < 0){
        scrollToTopCard();
    } else if (currentCardIdx.value - 1 < 0){
        return
    }else {
        currentCardIdx.value--;
        calculateTotalOffset();
        currentAppliedOffset.value = activePostOffset.value;
        isHiding.value = false;
        //cardListRefs.value[currentCardIdx.value].children[0].focus()
    }
}

onMounted(() => {
    setInterval(() => {
        currentTime.value = Date.now();
        calculateTotalOffset();
    }, 100)


    window.addEventListener('select', scrollToTopCard)
    window.addEventListener('up-scroll', scrollUp)
    window.addEventListener('down-scroll', scrollDown)
    window.addEventListener('focus-updated', onFocusUpdated)
    window.addEventListener('toast-added', toastAdded)
    window.addEventListener('toast-cleared', toastCleared)
})

onUnmounted(() => {
    window.removeEventListener('select', scrollToTopCard)
    window.removeEventListener('up-scroll', scrollUp)
    window.removeEventListener('down-scroll', scrollDown)
    window.removeEventListener('focus-updated', onFocusUpdated)
    window.removeEventListener('toast-added', toastAdded)
    window.removeEventListener('toast-cleared', toastCleared)
})

</script>

<template>
    <div class="toast-overlay">
        <div class = "toast-hide-wrapper">

            <div class="toast-area" :style="{ transform: `translateY(${currentAppliedOffset}px)`, opacity: isHiding ? 0 : 1 }">
                <div class="toast" ref="card-list" :style="{ opacity: calculateFadeoutOpacity(index) }"
                    v-for="(currentToast, index) in renderedCardList" :key="currentToast.post.id">

                    <!-- [-1] Upcoming Fight Toast -->
                    <button class="toast-modal-card focusable" v-if="currentToast.post.type == -1">
                        <div class="overlay-border"></div>
                        <div class="content-event">
                            <div class="textarea">
                                <div class="event-name">
                                    {{ formatEventName(currentToast.post.body.name) }}
                                </div>
                                <div class="event-date">
                                    {{ formatTimestamp(currentToast.post.body.startTime, "Main Card") }}
                                </div>
                                <div class="event-location">
                                    {{ currentToast.post.body.location.Venue }}
                                </div>
                                <div class="event-location" v-if="currentToast.post.body.location.TriCode === 'USA'">
                                    {{ currentToast.post.body.location.City }}, {{ currentToast.post.body.location.State
                                    }}
                                </div>
                                <div class="event-location" v-else>
                                    {{ currentToast.post.body.location.City }}, {{
                                        currentToast.post.body.location.Country
                                    }}
                                </div>
                            </div>
                        </div>
                    </button>

                    <!-- [0/1] Text/Image Toast -->
                    <button class="toast-modal-card focusable"
                        v-if="currentToast.post.type == 0 || currentToast.post.type == 1">
                        <div class="overlay-border"></div>
                        <div class="content-col">
                            <img class="card-image" v-if="currentToast.post.imageData != null"
                                :src="currentToast.post.imageData.dataUri">
                            <div class="textarea">
                                <div class="subtitle">
                                    {{ currentToast.post.body }}
                                </div>
                            </div>
                        </div>

                    </button>
                    <!-- [2] Social Post Toast -->
                    <button class="toast-modal-card focusable" v-else-if="currentToast.post.type == 2">
                        <div class="overlay-border"></div>
                        <social-content :post="currentToast.post.body"></social-content>
                    </button>
                    <button class="toast-modal-card focusable" v-else-if="currentToast.post.type == 3">
                        <div class="overlay-border"></div>
                        <div class="content-stat">
                            <div v-if="currentToast.post.body.statType == 0">
                                <div class="name-row">
                                    <div class="content-name">
                                        {{ currentToast.post.body.fighterName0.FirstName }} {{
                                            currentToast.post.body.fighterName0.LastName }}
                                    </div>
                                    <div class="content-name">
                                        {{ currentToast.post.body.fighterName1.FirstName }} {{
                                            currentToast.post.body.fighterName1.LastName }}
                                    </div>
                                </div>
                                <div class="stat-row">
                                    <div class="stat-left">
                                        {{ currentToast.post.body.statValue0 }}
                                    </div>
                                    <div class="stat-name">
                                        {{ currentToast.post.body.statName }}
                                    </div>
                                    <div class="stat-right">
                                        {{ currentToast.post.body.statValue1 }}
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="currentToast.post.body.statType == 1">
                                <div class="content-name">
                                    {{ currentToast.post.body.fighterName.FirstName }} {{
                                        currentToast.post.body.fighterName.LastName }}
                                </div>
                                <div class="single-stat">
                                    <div class="value">
                                        {{ currentToast.post.body.statValue }}
                                    </div>
                                    <div class="stat-name">
                                        {{ currentToast.post.body.statName }}
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="currentToast.post.body.statType == 2">
                                <div class="content-name">
                                    {{ currentToast.post.body.fighterName.FirstName }} {{
                                        currentToast.post.body.fighterName.LastName }}
                                </div>
                                <div class="single-stat">
                                    <div class="value">
                                        {{ currentToast.post.body.statValue0 }}
                                    </div>
                                    <div class="stat-name">
                                        {{ currentToast.post.body.statName0 }}
                                    </div>
                                </div>
                                <div class="single-stat">
                                    <div class="value">
                                        {{ currentToast.post.body.statValue1 }}
                                    </div>
                                    <div class="stat-name">
                                        {{ currentToast.post.body.statName1 }}
                                    </div>
                                </div>
                                <div class="single-stat">
                                    <div class="value">
                                        {{ currentToast.post.body.statValue2 }}
                                    </div>
                                    <div class="stat-name">
                                        {{ currentToast.post.body.statName2 }}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </button>
                    <button class="toast-modal-card focusable" v-else-if="currentToast.post.type == 4">
                        <div class="overlay-border"></div>
                        <div class="content-row">
                            <img class="card-image" v-if="currentToast.post.imageData != null"
                                :src="currentToast.post.imageData.dataUri">
                            <div class="textarea">
                                <div class="subtitle">
                                    {{ currentToast.post.body.text }}
                                </div>
                            </div>
                        </div>
                        <img class="ufc-insights" src="../../public/assets/imgs/ufc-insights-logo.png">
                    </button>
                </div>
                <button class="hider-element focusable" ref="hider-element"></button>
            </div>
        </div>
        <transition name="fade">
            <div class="post-counter" v-if="currentCardIdx < totalPostsSize - 1 && currentCardIdx >= 0">
                <div>{{ totalPostsSize - currentCardIdx }}</div>
                <div class="line"></div>
                <div>{{ totalPostsSize }}</div>
            </div>
        </transition>

    </div>
    <div class="bottom-section flex-center"
        :class="{ 'has-toast': currentToast != null && currentToast.post.type != -1 }">
        <img class="ufc-bug" src="../../public/assets/imgs/ufc-bug.png">
    </div>
</template>

<style lang="scss" scoped>
@import '../sass/GlobalClasses';
@import '../sass/Settings';
@import '../sass/ToastStyling.scss';
@import '../sass/Transitions.scss';


.slideup-fade-enter-active,
.slideup-fade-leave-active {
    transition: all 1s ease;
}

.slideup-fade-enter-from,
.slideup-fade-leave-to {
    transform: translateY(200%);
    opacity: 0;
}

.bottom-section {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: vw(50, $glasses-width);

    opacity: 1;
    transition: opacity 1s ease;

    &.has-toast {
        opacity: 0.33;
    }

    .ufc-bug {
        position: relative;
        width: vw(62, $glasses-width);
    }
}

.toast-overlay {
    overflow: hidden;

    .post-counter {
        position: fixed;
        left: 0;
        bottom: vw(110);
        height: auto;
        width: vw(50);
        color: $text-0;
        font-size: vw(32);
        font-weight: 700;

        flex-direction: column;
        display: flex;
        justify-content: center;
        align-items: center;

        .line {
            position: relative;
            width: vw(20);
            height: vw(2);
            background-color: #BDBDBD;

        }
    }

    .toast-hide-wrapper{
        position: absolute;
        $bottom-margin: 50;
        bottom: vw($bottom-margin, $glasses-width);
        height: vw($glasses-width - $bottom-margin, $glasses-width);
        left: 0;
        right: 0;
        overflow: hidden;
    }

    .toast-area {
        position: absolute;
        bottom: vw(0, $glasses-width);
        height: auto;
        left: vw(36, $glasses-width);
        right: vw(36, $glasses-width);
        overflow-y: scroll;
        overflow-x: hidden;

        display: flex;
        flex-direction: column-reverse;
        justify-content: flex-start;

        transition: all ease 0.3s;

        .hider-element {
            width: 100%;
            position: relative;
            height: vw(100);
            opacity: 0;
        }

        .toast {
            position: relative;
            width: vw(352, $glasses-width);
            height: fit-content;
            margin: vw(5, $glasses-width) 0;

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .content-event {
                text-align: left;

                .event-name {
                    font-weight: 700;
                    font-size: vw(22, $glasses-width);
                    text-transform: uppercase;

                    margin-bottom: vw(2, $glasses-width);
                }

                .event-date {
                    font-weight: 400;
                    font-size: vw(15, $glasses-width);

                    margin-bottom: vw(4, $glasses-width);
                }

                .event-location {
                    font-weight: 400;
                    font-size: vw(12, $glasses-width);
                }
            }

            .content-stat {
                position: relative;
                font-weight: 700;
                font-size: vw(14, $glasses-width);
                text-align: left;
                width: 100%;
                padding: vw(5, $glasses-width);

                .name-row {
                    position: relative;
                    width: 100%;
                    height: auto;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: flex-start;
                }

                .stat-row {
                    position: relative;
                    width: 100%;
                    height: auto;
                    display: grid;
                    grid-template-columns: 1fr auto 1fr;
                    align-items: center;
                    column-gap: vw(8, $glasses-width);
                    margin-top: vw(5, $glasses-width);

                    .stat-left {
                        justify-self: start;
                        font-weight: 700;
                        font-size: vw(34, $glasses-width);
                        white-space: nowrap;
                        overflow: visible;
                    }

                    .stat-right {
                        justify-self: end;
                        font-weight: 700;
                        font-size: vw(34, $glasses-width);
                        white-space: nowrap;
                        overflow: visible;
                    }

                    .stat-name {
                        justify-self: center;
                        align-items: center;
                        width: auto;
                        max-width: vw(135, $glasses-width);
                        font-weight: 400;
                        font-size: vw(16, $glasses-width);
                        text-align: center;
                    }
                }

                .content-name {
                    position: relative;
                    font-weight: 700;
                    font-size: vw(18, $glasses-width);
                    text-transform: uppercase;
                    text-align: left;
                    width: auto;
                    margin-bottom: vw(5, $glasses-width);
                }

                .single-stat {
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    height: auto;

                    .value {
                        position: relative;
                        height: auto;
                        font-weight: 700;
                        font-size: vw(34, $glasses-width);
                        text-align: left;
                    }

                    .stat-name {
                        position: relative;
                        font-weight: 400;
                        font-size: vw(16, $glasses-width);
                        text-align: left;
                        margin-left: vw(10, $glasses-width);
                    }
                }

                
            }

            .content-row {
                position: relative;
                width: 100%;
                height: auto;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;

            }

            .content-col {
                position: relative;
                width: 100%;
                height: auto;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                gap: vw(12, $glasses-width);
            }

            .card-image {
                position: relative;
                width: 100%;
                max-height: vh(200, $glasses-width);
                object-fit: cover;
                height: auto;
                border-radius: vw(10, $glasses-width);
                margin-right: vw(8, $glasses-width);
            }

            .text-area {
                flex-grow: 1;
                height: auto;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
            }

            .title {
                position: relative;
                height: auto;
                text-align: left;
                font-size: vw(16, $glasses-width);
            }

            .subtitle {
                position: relative;
                height: auto;
                text-align: left;
                font-size: vw(22, $glasses-width);
                line-height: vw(26, $glasses-width);
                font-weight: 400;
                text-wrap: wrap;
            }

            .toast-modal-card {
                position: relative;
                width: vw(352, $glasses-width);
                height: fit-content;
                background-color: #27282D;
                border-radius: vw(20, $glasses-width);
                color: $text-0;

                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;

                padding-left: vw(15, $glasses-width);
                padding-right: vw(15, $glasses-width);
                padding-top: vw(15, $glasses-width);
                padding-bottom: vw(15, $glasses-width);

                border: none;

                //&:not(:focus) {
                //    opacity: 0.7;
                //}

                .overlay-border {
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    z-index: 1;
                    opacity: 60%;
                    /* placed behind card's contents (pointer-events: none works too) */
                    border: solid vw(1.25, $glasses-width) #0000;
                    /* reserve space for the border */
                    border-radius: inherit;
                    /* ensure gradient size is relative to border-box (not default padding-box) */
                    background: linear-gradient(20deg, rgba(255, 255, 255, .6) 0%, rgba(0, 0, 0, 0) 100%) border-box;
                    mix-blend-mode: overlay;
                    --lyr: conic-gradient(red 0 0);
                    /* any kind of gradient that's opaque everywhere */
                    /* exclude padding-box (that is, mask out everything but the border area) */
                    mask: var(--lyr) padding-box exclude, var(--lyr);
                    content: ''
                }

            }

        }
    }

}
</style>
